import React from 'react'
import Phonecall from "../../Images/phoencalimage.png"
import Address from "../../Images/adressimage.png"
import Emailimage from "../../Images/emailimage.png"
import {
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Button,
    Box
  } from '@chakra-ui/react'
import { useState } from 'react'
function FaqsPage() {

    const [expandedIndex, setExpandedIndex] = useState(null);

    const handleToggle = (index) => {
      setExpandedIndex(expandedIndex === index ? null : index);
    };
  return (
   <>
      <div
          id="faqs-page"
          className="bg-white w-full py-12  text-center font-oswald"
        >
          <div className=" flex items-center justify-center">
            <p
              style={{ backgroundColor: "#EFEEFE" }}
              className="  rounded-full py-2 px-6 font-bold text-bgBlue"
            >
             FAQ'S
            </p>
          </div>
          <br />
          <h2 className="text-3xl font-bold text-gray-900  animate-fade-in">
            Frequently Ask<span className="text-purple">  Questions </span>{" "}
          </h2>
         
         

          <div className='lg:w-4/5 m-auto shadow-xl mt-4'>
      <Accordion index={expandedIndex} allowToggle>
        <AccordionItem>
          <h2>
            <AccordionButton onClick={() => handleToggle(0)} _expanded={{ bg: '#4D2C5E', color: 'white' }}>
              <Box as='span' flex='1' textAlign='left' fontSize={18} fontWeight={600}>
                What is Quize?
              </Box>
              <AccordionIcon color={"#FF782D"} boxSize={8} />
            </AccordionButton>
          </h2>
          <AccordionPanel pb={4} textAlign={'start'}>
            Quize is designed for aspirants preparing for civil services exams like UPSC, State PSC, SSC, Banking, Railway, etc. By solving questions, you can brush up and enhance your knowledge for cracking jobs. Here, you can see your reports like right answers, wrong answers, and justified knowledge.
          </AccordionPanel>
        </AccordionItem>

        <AccordionItem>
          <h2>
            <AccordionButton onClick={() => handleToggle(1)} _expanded={{ bg: '#4D2C5E', color: 'white' }}>
              <Box as='span' flex='1' textAlign='left' fontSize={18} fontWeight={600}>
                How to get started with Learn2Earn24x7?
              </Box>
              <AccordionIcon color={"#FF782D"} boxSize={8}/>
            </AccordionButton>
          </h2>
          <AccordionPanel pb={4} textAlign={'start'}>
            <ol>
              <li>Download the mobile App.</li>
              <li>Register with us, choose a course as per your preferences, and pay.</li>
              <li>Go to the dashboard and start solving questions.</li>
              <li>Receive payment for the work done directly to your bank account.</li>
            </ol>
          </AccordionPanel>
        </AccordionItem>

        <AccordionItem>
          <h2>
            <AccordionButton onClick={() => handleToggle(2)} _expanded={{ bg: '#4D2C5E', color: 'white' }}>
              <Box as='span' flex='1' textAlign='left' fontSize={18} fontWeight={600}>
                How much can we earn from Learn2Earn24x7?
              </Box>
              <AccordionIcon color={"#FF782D"} boxSize={8}/>
            </AccordionButton>
          </h2>
          <AccordionPanel pb={4} textAlign={'start'}>
            There is no earning limit. Many Learn2Earn24x7 users earn 20k to 30k per month by working just 6-7 hours a day.
          </AccordionPanel>
        </AccordionItem>

        <AccordionItem>
          <h2>
            <AccordionButton onClick={() => handleToggle(3)} _expanded={{ bg: '#4D2C5E', color: 'white' }}>
              <Box as='span' flex='1' textAlign='left' fontSize={18} fontWeight={600}>
                What are the Payment withdrawal options?
              </Box>
              <AccordionIcon color={"#FF782D"} boxSize={8}/>
            </AccordionButton>
          </h2>
          <AccordionPanel pb={4} textAlign={'start'}>
            Learn2Earn24x7 provides four payment options: IMPS/NEFT.
          </AccordionPanel>
        </AccordionItem>

        <AccordionItem>
          <h2>
            <AccordionButton onClick={() => handleToggle(4)} _expanded={{ bg: '#4D2C5E', color: 'white' }}>
              <Box as='span' flex='1' textAlign='left' fontSize={18} fontWeight={600}>
                Are there any targets or conditions?
              </Box>
              <AccordionIcon color={"#FF782D"} boxSize={8}/>
            </AccordionButton>
          </h2>
          <AccordionPanel pb={4} textAlign={'start'}>
            There are no targets, no accuracy requirements, and no extra deductions—just solve questions and receive daily cash payments.
          </AccordionPanel>
        </AccordionItem>

        <AccordionItem>
          <h2>
            <AccordionButton onClick={() => handleToggle(5)} _expanded={{ bg: '#4D2C5E', color: 'white' }}>
              <Box as='span' flex='1' textAlign='left' fontSize={18} fontWeight={600}>
                How does it work?
              </Box>
              <AccordionIcon color={"#FF782D"} boxSize={8}/>
            </AccordionButton>
          </h2>
          <AccordionPanel pb={4} textAlign={'start'}>
          It works by letting users complete quizzes, courses, and tasks to earn rewards or income based on their performance and activity.           </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </div>
        </div>
   </>
  )
}

export default FaqsPage
